export enum SystemInfo {
  salesEmailUrl = 'sales@wandify.io',
  supportEmailUrl = 'support@wandify.io',
  UTMSource = 'utm_source',
  gaCookieKey = '_ga'
}
